import { getTypedAncestorTracker } from '../utils/helper'

export default getTypedAncestorTracker('table')
